import { Exclude, Transform, Type } from 'class-transformer';

import { booleanTransform, centTransform, dateTransform } from '../utils/helper';
import { Campaign } from './campaign.model';
import { Contatto } from './contatto.model';
import { InsModDate } from './date.model';
import { User } from './user.model';

export class Offer extends InsModDate {
	id!: number;
	hqid!: number;
	contactid!: number;
	campaignid!: number;
	operatorid!: number;
	callid!: number;
	@Transform(dateTransform)
	calldate?: Date;
	category?: string;
	@Transform(centTransform)
	amount?: number;
	paymode!: string;
	address?: string;
	streetno?: string;
	city?: string;
	comune?: string;
	province?: string;
	zipcode?: string;
	telephone?: string;
	note?: string;
	email?: string;
	shipmentstatus?: ShipmentStatus;
	@Transform(booleanTransform)
	emailsent?: boolean;
	@Transform(booleanTransform)
	envelopegenerated?: boolean;
	@Transform(dateTransform)
	emaildate?: Date;
	@Transform(dateTransform)
	envelopdate?: Date;
	deliveryid?: number;
	@Transform(dateTransform)
	deliverydate?: Date;
	@Transform(dateTransform)
	deliveryrejectdate?: Date;
	@Transform(booleanTransform)
	quotaassociativa?: boolean;
	@Transform(booleanTransform)
	emptybollettino?: boolean;
	@Transform(booleanTransform)
	undodelivery?: boolean;

	@Type(() => Contatto)
	@Exclude({ toPlainOnly: true })
	contact?: Contatto;
	@Type(() => Campaign)
	@Exclude({ toPlainOnly: true })
	campaign?: Campaign;
	@Type(() => User)
	@Exclude({ toPlainOnly: true })
	user?: User;
	@Type(() => User)
	@Exclude({ toPlainOnly: true })
	fattorino?: User;

	get isPending(): boolean {
		return this.shipmentstatus === ShipmentStatus.PENDING;
	}

	get isDelivered(): boolean {
		return this.shipmentstatus === ShipmentStatus.DELIVERED;
	}

	get isPaymodeBank(): boolean {
		return this.paymode === OfferPayMode.PAYMENT_METHOD_BANKTRANSFER;
	}

	get isPaymodeSede(): boolean {
		return this.paymode === OfferPayMode.PAYMENT_METHOD_SEDE;
	}

	get isPaymodeBollettino(): boolean {
		return this.paymode === OfferPayMode.PAYMENT_METHOD_BOLLETTINO;
	}

	get isPaymodeAssegno(): boolean {
		return this.paymode === OfferPayMode.PAYMENT_METHOD_ASSEGNO;
	}
}

export class FattorinoStats {
	@Transform(dateTransform)
	date!: Date;
	fullname!: string;
	@Transform(centTransform)
	qa!: number;
	@Transform(centTransform)
	cvolontario!: number;
	@Transform(centTransform)
	importo!: number;
	rimborso!: number;
}

export class Rettifica extends InsModDate {
	id!: number;
	deliveryid!: number;
	@Transform(dateTransform)
	offerprintdate!: Date;
	@Transform(centTransform)
	amount!: number;
}

export enum ShipmentStatus {
	TO_BE_ASSIGNED = 'tobeassigned',
	ASSIGNED = 'assigned',
	PENDING = 'pending',
	TO_BE_PRINTED = 'tobeprinted',
	DELIVERED = 'delivered',
	REJECTED = 'rejected',
	NO_PAYMODE = 'nopaymode'
}

export enum OfferPayMode {
	PAYMENT_METHOD_CASH = 'cash',
	PAYMENT_METHOD_BOLLETTINO = 'bollettino',
	PAYMENT_METHOD_BANKTRANSFER = 'banktransfer',
	PAYMENT_METHOD_SEDE = 'sede',
	PAYMENT_METHOD_ASSEGNO = 'assegno',
}